var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "navbarCategories" }, [
    _c("img", {
      staticClass: "check-img",
      class: _vm.qaName,
      attrs: { src: require("@/assets/images/self-care/arrow-left.png") },
      on: { click: _vm.handleClickPrevPage },
    }),
    _c("p", { staticClass: "grayLightMouse headline-medium" }, [
      _vm._v(_vm._s(_vm.$t(_vm.titleNavbar))),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }